
export default {
    state: {
        openCloseStatus: {
            status: false,
            content: 'form'
        },
        superMasterStatus: false,
        userModalStatus: false,
        userInfo: {
            avatar: ''
        }
    },
    mutations: {
        setUserInfo (state, val) {
            state.userInfo = val
        },
        changeStatus (state, val) {
            state.openCloseStatus.status = val.status
            state.openCloseStatus.content = val.content
        },
        changeSuperMasterStatus (state, val) {
            state.superMasterStatus = val
        },
        changeUserModalStatus (state, val) {
            state.userModalStatus = val
        }
    },
    actions: {
        changeModuleAMsgAction ({commit}, val) {
            commit('changeModuleA', val)
        }
    },
    namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/user/index.js